export const Functions = {
  create: false,
  delete: true,
  detail: true,
  search: true,
};

export const PageName = '全面兑换列表';
